import React from 'react'
import { formatHelper } from '../../../../common/helpers'
import { TableRowField } from '../../../../components'




export function columnsXS(columnOption) {
    return ([
        {
            dataField: 'id',
            text: 'Pedido',
            formatter: (cell, row) => {
                return (
                    <div>
                        <TableRowField label='Tienda:' value={row.Store.name} />
                        <TableRowField label='Cantidad:' value={row.quantity} />
                        <TableRowField label='Costo Total (S/):' value={row.total_price} />
                        <TableRowField label='Fecha de Recepción:' value={formatHelper.toDateDDMMYYY(row.reception_date)} />
                        <TableRowField label='Estado:' value={row.completed == true ? 'Recibido' : 'Pendiente'} />
                    </div>
                )
            }
        },
        columnOption
    ])
}


export function columnsSM(columnOption) {
    return ([
        {
            dataField: 'Store.name',
            text: 'Tienda'
        },
        {
            dataField: 'quantity',
            text: 'Cantidad'
        },
        {
            dataField: 'total_price',
            text: 'Costo Total (S/)',
            formatter: (cell) => {
                return <span>{formatHelper.toMoney(cell)}</span>
            }
        },
        {
            dataField: 'reception_date',
            text: 'Fecha de Recepción',
            formatter: (cell) => {
                return <span>{formatHelper.toDateDDMMYYY(cell)}</span>
            }
        },
        {
            dataField: 'completed',
            text: 'Estado',
            formatter: (cell) => {
                return <span>{cell == true ? 'Recibido' : 'Pendiente'}</span>
            }
        },
        columnOption
    ])
}


// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductOrderList/_columns.js